<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Toetsen</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="filteredData" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setExam()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add Exam
					</v-btn>
					<v-spacer></v-spacer>
					<v-select
						v-model="selectedPeriode"
						:items="periodes"
						item-text="name"
						item-value="id"
						label="Periode"
						dense
						hide-details
						dark
						clearable
						class="mt-0 pt-0 mr-2"
						style="max-width: 180px"
					></v-select>
					<v-select
						v-model="selectedExamType"
						:items="examTypes"
						item-text="name"
						item-value="id"
						label="Examen type"
						dense
						hide-details
						dark
						clearable
						class="mt-0 pt-0 mr-2"
						style="max-width: 220px"
					></v-select>
					<v-btn
						v-if="showHerkansingActions"
						depressed
						class="mr-2"
						color="inverted"
						:disabled="!selectedPeriode || bulkLoading"
						:loading="bulkLoading"
						@click="bulkFlag('locked')"
					>
						<v-icon class="pr-2">{{ allLocked ? 'mdi-lock-open' : 'mdi-lock' }}</v-icon>{{ lockButtonLabel }}
					</v-btn>
					<v-btn
						v-if="showHerkansingActions"
						depressed
						class="mr-2"
						color="inverted"
						:disabled="!selectedPeriode || bulkLoading"
						:loading="bulkLoading"
						@click="bulkFlag('locked_display')"
					>
						<v-icon class="pr-2">{{ allHidden ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>{{ displayButtonLabel }}
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.locked="{ item }">
				{{ Number(item.locked) === 1 ? 'Ja' : 'Nee' }}
			</template>
			<template v-slot:item.locked_display="{ item }">
				{{ Number(item.locked_display) === 1 ? 'Verborgen' : 'Zichtbaar' }}
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>

		<v-snackbar v-model="snackbar" bottom right :color="snackColor" :timeout="4000">
			{{ snackText }}
			<v-btn dark text @click="snackbar = false">Sluiten</v-btn>
		</v-snackbar>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
import { API_ROOT } from "../../config";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "exams",
	data() {
		return {
			//user: localStorage.getItem("user"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Examen", value: "tbl_sys_exam_type.name" },
				{ text: "Sector", value: "tbl_sys_sector.name" },
				
				{ text: "Opleiding", value: "tbl_sys_study.name" },
				{ text: "Klas", value: "tbl_sys_class.name" },
				{ text: "Periode", value: "tbl_sys_periode.name" },
				{ text: "Deelkwalificatie", value: "tbl_sys_subject.name" },
				{ text: "Module", value: "tbl_teacher_subject_class.module" },
				{ text: "Docent", value: "tbl_employee.teacher_name" },
				{ text: "Vergrendeld", value: "locked" },
				{ text: "Weergave", value: "locked_display" }
				
				// { text: "Omschrijving", value: "description" },
				
				// { text: "First Check", value: "firstcheckby"},
				// { text: "Second Check",	value: "secondcheckby"},
				// { text: "Active", value: "tbl_exam.exam_active" }

			],
			// semesters: [],
			// studies: [],
			// exams: [],
			// examtypes: [],
			// selected_exam: null,
			// selected_kwalificatie: null,
			// selected_deelkwalificatie: null,
			// selected_semester: null,
			// schoolyear: [],
			// selected_schoolyear: null,
			data: [],
			periodes: [],
			examTypes: [],
			selectedPeriode: null,
			selectedExamType: null,
			bulkLoading: false,
			snackbar: false,
			snackText: "",
			snackColor: "green",
			// banktypes: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		// this.getBanktypes();
		this.getExam();
		this.getPeriodes();
		this.getExamTypes();
	},
	watch: {
		// selected_kwalificatie: function(value) {
		// 	this.getStudyExamtype(value);
		// 	console.log(value);
		// }
	},
	computed: {
		filteredData: function() {
			var periodeId = this.selectedPeriode;
			var examTypeId = this.selectedExamType;
			return this.data.filter(function(row) {
				if (periodeId && Number(row.periode_id) !== Number(periodeId)) {
					return false;
				}
				if (examTypeId && Number(row.exam_type_id) !== Number(examTypeId)) {
					return false;
				}
				return true;
			});
		},
		showHerkansingActions: function() {
			return Number(this.selectedExamType) === 8;
		},
		periodHerkansingen: function() {
			var periodeId = this.selectedPeriode;
			if (!periodeId) {
				return [];
			}
			return this.data.filter(function(row) {
				return Number(row.periode_id) === Number(periodeId) && Number(row.exam_type_id) === 8;
			});
		},
		allLocked: function() {
			var rows = this.periodHerkansingen;
			return rows.length > 0 && rows.every(function(row) {
				return Number(row.locked) === 1;
			});
		},
		allHidden: function() {
			var rows = this.periodHerkansingen;
			return rows.length > 0 && rows.every(function(row) {
				return Number(row.locked_display) === 1;
			});
		},
		lockButtonLabel: function() {
			return this.allLocked ? "Ontgrendel" : "Vergrendel";
		},
		displayButtonLabel: function() {
			return this.allHidden ? "Tonen" : "Verbergen";
		}
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/exam/update/" + id
			});
		},
		setExam: function() {
			this.$router.push({
				path: "/schooladmin/exam/new"
			});
		},
		getPeriodes: function() {
			var self = this;
			ax.get("/periode/all").then(function(response) {
				self.periodes = response.data;
			});
		},
		getExamTypes: function() {
			var self = this;
			ax.get("/exam_type/all").then(function(response) {
				self.examTypes = response.data;
			});
		},
		bulkFlag: function(field) {
			var self = this;
			if (!this.selectedPeriode || Number(this.selectedExamType) !== 8 || this.bulkLoading) {
				return;
			}
			var value = field === "locked" ? (this.allLocked ? 0 : 1) : (this.allHidden ? 0 : 1);
			var action = field === "locked"
				? (value === 1 ? "vergrendelen" : "ontgrendelen")
				: (value === 1 ? "verbergen" : "tonen");
			if (!window.confirm("Alle herkansingen in deze periode " + action + "?")) {
				return;
			}
			this.bulkLoading = true;
			ax.post("/exam/bulk_period_flags", {
				periode_id: this.selectedPeriode,
				exam_type_id: 8,
				field: field,
				value: value
			}).then(function(response) {
				var count = response.data && response.data.updated != null ? response.data.updated : 0;
				self.snackColor = "green";
				self.snackText = count + " toetsen bijgewerkt";
				self.snackbar = true;
				self.bulkLoading = false;
				self.getExam();
			}).catch(function() {
				self.snackColor = "red";
				self.snackText = "Bijwerken is mislukt";
				self.snackbar = true;
				self.bulkLoading = false;
			});
		},
		getExam: function() {
			var self = this;
			this.loading = true;
			ax.get("/exam/all").then(function(response) {
					// console.log(response.data);
				self.data = response.data;
				console.log("Exams fetched...");
				console.log(response.data);
				self.loading = false;
			});
		},
		// getBanktypes: function() {
		// 	var self = this;
		// 	ax.get("/banktype/all").then(function(response) {
		// 		console.log(response.data);
		// 		self.banktypes = response.data;
		// 	});
		// }
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>